export default __webpack_public_path__ + "static/media/en-flag.245c2f92.svg";